import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-app-store-icon',
  templateUrl: 'app-store.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppStoreIcon { }
